module.exports = __webpack_public_path__ + "static/media/108-smartphone.daf3b178.svg";